import $ from 'jquery';
import 'bootstrap-table';
import 'bootstrap-table/dist/extensions/sticky-header/bootstrap-table-sticky-header';
import 'bootstrap-table/dist/extensions/fixed-columns/bootstrap-table-fixed-columns';

const wrapper = $('.previous-games-block-game');
const setContainerWidth = () => {
    const bodyWidth = $('body').outerWidth();

    if (window.matchMedia('(max-width: 991.98px)').matches) {
        wrapper.css({
            width: bodyWidth,
            marginLeft: `calc(${-bodyWidth / 2}px + 50%)`,
        });
    } else {
        wrapper.css({
            width: '',
            marginLeft: '',
        });
    }
};

$(window).bind('resize', setContainerWidth).trigger('resize');

$('.ranking-block table').bootstrapTable({
    loadingTemplate: function () {
        return '';
    },
    fixedColumns: true,
    fixedNumber: 3,
    stickyHeader: true,
});
